import { ChevronRight } from "lucide-react"
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible"
import { useState } from "react"
import FlashcardItemMenu from "./flashcard-item-menu"
import type { SetDeck } from "@/services/api/flashcards/get-all"
import FlashcardDeckList from "./flashcard-deck-list"

interface CollapsableFlashcardListItemProps {
  flashcard: SetDeck
}

const CollapsableFlashcardListItem = ({ flashcard }: CollapsableFlashcardListItemProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const getTextBySourceType = () => {
    switch (flashcard.sourceType) {
      case "unknown":
        return ""
      case "document":
        return `Páginas: ${flashcard.startPage} - ${flashcard.endPage} • `
      case "user_input":
        return "Generada con IA • "
      default:
        return ""
    }
  }

  return flashcard.decks.length > 0 ? (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <div className="flex w-full items-center justify-between gap-4 rounded-[8px] p-2 transition duration-300 hover:bg-neutral-100">
        <CollapsibleTrigger className="flex w-full items-center justify-between">
          <div className="flex items-center justify-center gap-3">
            <ChevronRight
              className={`text-gray-500 transition-transform duration-200 ${isOpen ? "rotate-90" : "rotate-0"}`}
            />

            <div className="flex w-full flex-col items-start overflow-hidden">
              <span className="block w-[28ch] break-words text-left text-sm font-bold">
                {flashcard.name}
              </span>
              <span className="text-xs font-normal text-gray-400">
                {getTextBySourceType()}{" "}
                {`${flashcard.decks.length} ${flashcard.decks.length === 1 ? "Mazo" : "Mazos"}`}
              </span>
            </div>
          </div>
        </CollapsibleTrigger>

        <div className="flex shrink-0 items-center justify-center">
          <FlashcardItemMenu flashcard={flashcard} />
        </div>
      </div>
      <CollapsibleContent className="mt-3 w-full">
        <FlashcardDeckList decks={flashcard.decks} />
      </CollapsibleContent>
    </Collapsible>
  ) : null
}

export default CollapsableFlashcardListItem
